import React from "react";
import { CircleCheckIcon, LockIcon, MailIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { heroChips, mockupImage } from "../data/content";
const trust = [{
  icon: LockIcon,
  label: "Paiement sécurisé"
}, {
  icon: MailIcon,
  label: "Livraison par e-mail"
}, {
  icon: ShieldCheckIcon,
  label: "Garantie 10 jours"
}];
export function Hero() {
  return <section className="bg-ink px-4 pb-10 pt-5 sm:px-6 lg:flex lg:min-h-[100svh] lg:items-center lg:py-10" data-id="element-79" data-mp="129qtzk94hnnc">
      <div className="mx-auto grid w-full max-w-6xl items-center gap-5 lg:grid-cols-[1.05fr_1fr] lg:gap-12" data-id="element-80" data-mp="xbfk59itvd54">
        <div className="text-center lg:text-left" data-id="element-81" data-mp="s9zypgcqn4m7">
          <p className="inline-flex items-center gap-2 rounded-full border border-golddark bg-gold/5 px-3 py-1.5 text-[10px] font-semibold tracking-[0.16em] text-gold sm:text-xs" data-id="element-82" data-mp="nc87kojx3mj2">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-83" data-mp="3czfoc8080na9" />
            LA MÉTHODE POUR PROFESSEURS DE GUITARE
          </p>
          <h1 className="mt-3 font-display text-[34px] font-bold uppercase leading-[0.92] text-white sm:text-6xl lg:mt-5 lg:text-[68px]" data-id="element-84" data-mp="3j896tarbk7oh">
            Votre prochain cours de guitare, <span className="text-gold" data-id="element-85" data-mp="39acysrtohsul">prêt en 5 minutes.</span>
          </h1>

          {/* Mobile: mockup + button right under the title, all above the fold */}
          <img src={mockupImage} alt="Le pack Le Maître de la Guitare : 2 livres et 5 bonus" className="mx-auto mt-4 max-h-[38svh] w-full max-w-xl rounded-xl object-contain lg:hidden" data-id="element-86" data-mp="3e7uzxw1gf3s1" />
          <CtaButton label="Voir l'offre complète" action="offer" className="mt-5 w-full sm:w-auto lg:hidden" data-id="element-87" data-mp="2qjv80ssep7bv" />

          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg lg:mx-0" data-id="element-88" data-mp="2violil7p0yc1">
            2 livres complémentaires et 5 bonus en PDF : un guide théorique pour préparer vos explications, un livre pratique pour faire travailler vos élèves, et des ressources prêtes à imprimer.
          </p>

          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-89" data-mp="s2b7vyavsj55">
            {heroChips.map(c => <li key={c} className="flex items-center gap-1.5 text-sm font-semibold text-white" data-id="element-90" data-mp="na09izvsh5ep">
                <CircleCheckIcon className="h-4 w-4 text-gold" aria-hidden data-id="element-91" data-mp="ichxv1qe0c30" />
                {c}
              </li>)}
          </ul>

          <CtaButton label="Voir l'offre complète" action="offer" className="mt-7 hidden lg:inline-flex" data-id="element-92" data-mp="1b0ni7ndj3z2b" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-93" data-mp="161az9dps3c50">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-xs text-white/60 sm:text-sm" data-id="element-94" data-mp="110wpnr8j3u4v">
                <Icon className="h-4 w-4 text-gold" aria-hidden data-id="element-95" data-mp="x0ut1whnhqwg" />
                {label}
              </li>)}
          </ul>
        </div>

        <img src={mockupImage} alt="Le pack Le Maître de la Guitare : 2 livres et 5 bonus" className="hidden max-h-[80svh] w-full rounded-2xl object-contain lg:block" data-id="element-96" data-mp="3hr3tc077qj7x" />
      </div>
    </section>;
}